import './style.scss'

import TableTeams from 'components/molecules/TableTeams'
import { TeamSideId } from 'features/team/const'
import { leftSideHooks } from 'shared/hooks'

import { useLegacyPersonas } from '../useLegacyPersonas'

export function MembersPage() {
	const [personas, { refetch }] = useLegacyPersonas()
	leftSideHooks.useActive(TeamSideId.Members)

	return <TableTeams getPersonas={refetch} personas={personas} />
}
